import type { TransactionPredicate } from './types';
import { isEqualAmount } from '../amounts/isEqualAmount';

export const accountingAmountDiffersFromBookingAmount: TransactionPredicate = ({
    amount,
    amountAccounting,
}) => !!amountAccounting && !isEqualAmount([amountAccounting, amount], Math.abs);
